<app-web-loader *ngIf="isLoader"></app-web-loader>

<div class="main-agent-post-div">
    <div class="agentSearchDiv">
        <div class="modal-content">
            <div class="modal-body">
                <div class="searchbtnDiv">
                <div class="search_ic"><img src="assets/images/icons/search_icon.png"></div>
                <input placeholder="Search Areas" type="text" id="txt-search" class="form-control txt-search"
                    (keyup)="doSearch($event)" autocomplete="off" />
                    <button type="button" class="btn btn_search" (click)="LoadAgentsByAreas()">Search</button>
                    </div>
                <div style="margin-top: 50px;"></div> <!-- Adjust the margin-top value as needed -->
               <div class="custom_search">
                <div class="custom-control custom-checkbox" *ngFor="let area of arrList">
                    <input type="checkbox" (change)="addPreferredAreas($event, area)" class="custom-control-input"
                        id="area{{area.AreaID}}">
                    <label class="custom-control-label" for="area{{area.AreaID}}">{{ area.AreaName }}</label>
                </div></div>
                <div class="searchbtnDiv" *ngIf="arrList.length > 0">
                    <button type="button" class="btn btn-sm btn-block btn-success"
                        (click)="LoadAgentsByAreas()">Search</button>
                </div>
            </div>
        </div>
        <div class="search_result" *ngIf="selectedAreasID.length > 0">
            <div class="selected-location-div">
                <p *ngFor="let selArs of selectedAreasID">
                    {{ selArs.AreaName }}
                    <span (click)="removePreferredAreas(selArs)"><i class="fas fa-times"></i></span>
                </p>
            </div>
        </div>
    </div>
   
    <div class="agentsListDiv">
        <div class="row">
            <div class="col-sm-6" *ngFor="let agents of agentsList">
        <div class="mrg15B card_div">
            <h5 class="card-title">{{ agents.AGENT_Name }}</h5>
            <div class="card-body padding-7px">
                <div class="row">
                    <div class="col-4 col-4">
                        <img [src]="agents?.AgentLogo || 'assets/images/ContactDP.png'" class="img-fluid" style="height: 150px; width: 150px;" />
                      </div>
                    <div class="col-8 col-8">
                        <p class="card-text mb-1" style="font-size: 18px; font-weight: bold;">{{ agents.CompanyName
                            }}</p>
                        <p class="card-text mb-1">{{ agents.User_Address }}</p>

                        <p class="card-text mb-1">
                            <img src="assets/images/Areas.png" alt="Icon" class="icon-class" width="15"
                                height="15" />
                            <small class="text-muted">{{ ReturnPreferredAreasNames(agents.AREAS_JSON) }}</small>
                        </p>

                        <button type="button" (click)="gotoAgentPostViews(agents)" class="btn btn-dark view_btn">View
                            Posts</button>
                    </div>
                </div>           
        </div>
    </div></div></div>
    </div>
</div>